// extracted by mini-css-extract-plugin
export default {"unit":"_unit_XxT3Iu","result":"_result_FBf1mC"};